import { render, staticRenderFns } from "./applyHistory.vue?vue&type=template&id=4754763f&scoped=true"
import script from "./applyHistory.vue?vue&type=script&lang=js"
export * from "./applyHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4754763f",
  null
  
)

export default component.exports